// Tiny shared flag so FirstVisitGuide.vue knows to stay quiet while
// OnboardingTour.vue is actively walking someone through the app —
// otherwise the two popups could show at the same time. Not Vuex: this
// has nothing to do with the app's real (mostly unused) store, see
// docs/KNOWN_ISSUES.md.
import { reactive } from "vue";

export const tourState = reactive({
  active: false,
});
